import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { PaymentV2Service, StorageService, UtilService, VariablesService, VwoService } from '../../shared/services';
import { IPaymentSipConfig } from '../payment-sip/payment-sip.model';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-multi-cause-sip-selection',
  templateUrl: './multi-cause-sip-selection.component.html',
  styleUrls: ['./multi-cause-sip-selection.component.scss']
})
export class MultiCauseSipSelectionComponent implements OnInit, OnDestroy {

  @Input() config: IPaymentSipConfig = {};

  cause_list = [
    { type: 'medical', title: 'Medical', icon: 'medical_services' },
    { type: 'animals', title: 'Animals', icon: 'pets' },
    { type: 'food_hunger', title: 'Food & Hunger', icon: 'restaurant' },
    { type: 'education', title: 'Education', icon: 'school' }
  ]

  selected_causes = [];

  subs: Subscription[] = [];
  params;

  constructor(
    private paymentV2: PaymentV2Service,
    public util: UtilService,
    public vwo: VwoService,
    public actRoute: ActivatedRoute,
    private storage: StorageService,
    public vars: VariablesService
  ) { }

  ngOnInit(): void {
    this.params = this.actRoute.snapshot.queryParams;
    if (this.params?.utm_source?.match('internal_impact_calling')) {
      this.cause_list.push({ type: 'elderly', title: 'Elderly', icon: 'elderly' });
      this.cause_list.push({ type: 'women_girls', title: 'Women Empowerment', icon: 'woman' });
    }
    if (this.vwo.multi_cause_dm_AB() && this.params?.st === 'f') {
      const pre_sip_cause = this.params?.pre_sip_cause;
      const pre_sip_length = this.util.getLengthToMultiply(pre_sip_cause);
      if (pre_sip_length > 1) {
        this.selected_causes = pre_sip_cause;
        this.paymentV2.paymentConfig.next({ sip_cause: this.selected_causes, amount: this.params?.donated_amount / this.selected_causes?.length });
      }
    }
    this.subs.push(this.paymentV2.paymentConfig.subscribe((c) => {
      if (c) {
        this.config = { ...this.config, ...c };
        this.checkExistingSip();
      }
    }));
    let sip_cart: any[] = this.storage.getFromSession('multicause');
    if (sip_cart?.length > 0 && this.vars.pageName.match('impact_portfolio_stories')) {
      this.cause_list.forEach((element, i) => {
        if (sip_cart.includes(element?.type)) {
          this.selected_causes.push(element?.type);
        }
      });
      this.paymentV2.paymentConfig.next({ sip_cause: sip_cart });
    } else {
      this.causeSelect(this.cause_list[0]);
    }
  }

  checkExistingSip() {
    const exist_sip = this.config?.user?.listsubscriptions ? Object.keys(this.config?.user?.listsubscriptions) : null;
    if (exist_sip) {
      const newList = [];
      this.cause_list.forEach((element, i) => {
        if (!exist_sip.includes(element?.type)) {
          newList.push(element);
        }
      });
      this.cause_list = newList;
    }
  }

  causeSelect(item) {
    if (!this.selected_causes.includes(item?.type)) {
      this.selected_causes.push(item?.type);
    } else if (this.selected_causes.length > 1) {
      this.selected_causes.splice(this.selected_causes.indexOf(item?.type), 1);
    }
    this.paymentV2.paymentConfig.next({ sip_cause: this.selected_causes });
    if (this.selected_causes?.length >= 1 && this.vars.pageName.match('impact_portfolio_stories')) {
      this.selected_causes = this.selected_causes.filter((value) => { if (value) return value });
      this.storage.addSessionData('multicause', this.selected_causes);
    }
  }

  ngOnDestroy() {
    this.subs.forEach(s => s.unsubscribe());
  }

}
